import React from 'react'
import WelcomeSection from './components/WelcomeSection/WelcomeSection'
import ResourceSection from './components/RescourceSection/ResourceSection'
import FeedbackModule from './components/FeedbackModule/FeedbackModule'
import TabSection from './components/TabSection/TabSection'
import AdSection from './components/AdSection/AdSection'
import MatchScreenTracking from './components/Tracking/MatchScreenTracking'
import MatchScreenAppRedesigned from './redesign/MatchScreenAppRedesigned'
import { useMatchScreenRedesign } from './redesign/context/RedesignConfigContext'

import './styles/shared/globals.scss'
import './styles/MatchScreenGeneral.scss'

const MatchScreenApp = () => {
  const { enabled } = useMatchScreenRedesign()

  // Sunset: when redesign hits 100%, delete this branch + legacy ./components/*.
  if (enabled) {
    return <MatchScreenAppRedesigned />
  }

  return (
    <div className="match-screen-app">
      <MatchScreenTracking />
      <WelcomeSection />
      <TabSection />
      <AdSection />
      <ResourceSection />
      <FeedbackModule />
    </div>
  )
}

export default MatchScreenApp
